export const APP_VERSION_FULL = (globalThis as any).APP_VERSION_FULL as string; // set in init.ts
